const color = {
  lightGrey: "#666666",
  primaryAppColor: "#05a792",
  delayedColor: "#E84259",
  greyBorderColor: "#c4c4c4",
};

export default color;
